'use client';

import React, { useEffect, useState } from 'react';
import { Schedule } from './Schedule';
import type { IScheduleInMedcenter } from '@/entities/medcenter/model/types';
import type { MedcenterScheduleProps } from '../model/types';
export const MedcenterSchedule: React.FC<MedcenterScheduleProps> = ({
  medcenter
}) => {
  const [schedule, setSchedule] = useState<IScheduleInMedcenter[]>([]);
  useEffect(() => {
    setSchedule(medcenter.schedule || []);
  }, [medcenter]);
  return <Schedule schedule={schedule} data-sentry-element="Schedule" data-sentry-component="MedcenterSchedule" data-sentry-source-file="MedcenterSchedule.tsx" />;
};